import { Button, Col, Input, Row, Skeleton, Tabs, Table } from 'antd';
import { useEffect, useState } from 'react';

import service from '../../services/applicationErrorService';
import { recordError } from '../../utils/logService';
import moment from 'moment';
import { map, get } from "lodash";
import { SearchOutlined } from '@ant-design/icons';
import ViewApplicationLogs from './ViewApplicationLogs';

import {
  CheckboxSwitchery,
  Messages,
  Notify,
  openNotification,
  util,
} from '@seims/shared';

const ApplicationErrorList = () => {

    const title = "Application Logs";
    const subTitle = "List of errors generated by the applications";
    
    const [errorLog, setErrorLog] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [visible, setVisible] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [firstRecord, setFirstRecord] = useState(0);
    const [isNotSearchable, setIsNotSearchable] = useState(true);
    const [isSearchedResults, setIsSearchedResults] = useState(false);
    const [currentTab, setCurrentTab] = useState("seimscore");

    const tabList = [
        {
          key: "seimscore",
          label: "Back-Office",
        },
        {
          key: "pubweb",
          label: "Public Web",
        },
        {
          key: "events",
          label: "Events PWA",
        }
      ];

    useEffect(() => {
        getSystemErrors({type:currentTab});
    }, [])

    const columns = [
        // {
        //     title: "Application Name",
        //     dataIndex: "appName",
        //     key: "appName1",
        //     sorter: (a, b) => a.appName.localeCompare(b.appName),
        // },
        {
            title: "Date",
            dataIndex: "errorTime",
            key: "3",
            defaultSortOrder: "descend",
            sorter: (a, b) => new Date(a.errorTime) - new Date(b.errorTime)
            // sorter: (a, b) => a.errorTime.localeCompare(b.errorTime),
        },
        {
            title: "Error Description",
            dataIndex: "message",
            key: "message2",
            sorter: (a, b) => a.message.localeCompare(b.message),
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
            key: "mobile3",
            render: (value) => (<CheckboxSwitchery checked={value} disabled={true} />),
            // sorter: (a, b) => a.errorTime.localeCompare(b.errorTime),
        },
        {
            title: "Browser",
            dataIndex: "browserName",
            key: "Browser4",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "View-5",
            render: (_, record) => {
                return (
                    <>
                         <a key={"a-" + record.id} onClick={() => showModal(record)}>View </a>
                    </>
                );
            },
        }
    ]
    let msg = "";

    const getSystemErrors = async ({
            type = currentTab,
            first = firstRecord,
            max = pageSize,
            searchValue = searchText,
            clearSearch = true
        }) => {
        if (clearSearch) {
            setSearchText("");
            searchValue = null;
        }
        setTotal(0);
        const entity = "log";
        try {
            setLoading(true);
            const response = await service.getSystemErrors({
                type: type, 
                first: first, 
                max: max,
                text: searchValue 
            })

            if (response && response.status === 200) {
                var logData = [];
                const { data } = response;
                setTotal(data?.total);
                logData = data.results?.map((element) => ({
                    key: element.id,
                    id: element.id,
                    appName: element?.appName,
                    message: element.message,
                    errorTime: moment(element.errorTime).format("DD MMM YYYY, HH:mm"),
                    mobile: element.mobile,
                    browserName: element.browserName

                }));
                setErrorLog(logData);
                setFilteredData(logData);
                setLoading(false);
            }
            else if (response && response.status === 204) {
                setLoading(false);
                setErrorLog([]);
                setFilteredData([]);
            }
            else {
                setErrorLog([]);
                setFilteredData([]);
            }
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE, entity);
            openNotification("System failed to load errors", msg, Notify.ERROR);
            recordError(error);
        }
        setIsSearchedResults(searchValue !== null && searchValue !== undefined && searchValue !== "");
    }

    const globalSearch = (searchValue) => {

        if (searchValue === "") {
            setFilteredData(errorLog);
            return;
        }

        const reg = new RegExp(searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), "gi");

        var _filteredData = map(errorLog, (record) => {
            const appNameMatch = get(record, "appName").match(reg);
            const descriptionMatch = get(record, "message").match(reg);
            const browserMatch = get(record, "browserName").match(reg);

            if (!appNameMatch && !descriptionMatch && !browserMatch) {
                return null;
            }
            return record;
        }).filter((record) => record);

        setFilteredData(_filteredData);
    };
    const handleInputChange = (e) => {
        const { value: searchValue } = e.target;
        setSearchText(searchValue);
        // globalSearch(searchValue);
        setIsNotSearchable(searchValue.length === 0);

        if (searchValue === "" && isSearchedResults) {
            setFirstRecord(0);
            setCurrentPage(1);
            getSystemErrors({ searchValue: searchValue, clearSearch: false, first: 0 });
        }
    };
    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };

    const onPageChange = (page, size) => {
        const keepCurrentPage = pageSize === size;
        const first = keepCurrentPage ? (page - 1) * pageSize : 0;
        const newPage = keepCurrentPage ? page : 1;
        setFirstRecord(first);
        setPageSize(size);
        setCurrentPage(newPage);
        getSystemErrors({ first: first, max: size, clearSearch: false });
    }

    const handleSearchRequest = async () => {
        // Do nothing if searchText is empty on hitting enter
        if (searchText.length > 0) {
            setFirstRecord(0);
            getSystemErrors({ first: 0, clearSearch: false });
            setIsSearchedResults(true);
        }
    };

    const onTabChange = (type) => {

        setFirstRecord(0);
        setCurrentPage(1);
        setSearchText("");
        setCurrentTab(type);
        getSystemErrors({ type: type, first: 0 });
    };

    const showModal = (record) => {
        setVisible(record);
      };

    return (
        <div className='content'>
            <h1 className="center-align">{title}</h1>
            <div>{subTitle}</div>
            <Row>
                <Col xs={24} md={8}>

                    <Input
                        placeholder="Search application logs"
                        type="text"
                        onChange={handleInputChange}
                        onPressEnter={handleSearchRequest}
                        onPaste={handleInputChange}
                        value={searchText}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                    />
                </Col>
                <Col className="">
                    <Button
                        disabled={isNotSearchable}
                        key="Search"
                        value="Search"
                        type="primary"
                        onClick={handleSearchRequest}
                        style={{ marginLeft: 10 }}
                    >
                        Search
                    </Button>
                </Col>
            </Row>
            <div className="space"></div>
            <Tabs
                className=""
                type="card"
                onChange={onTabChange}
                items={tabList}
                key="repo-table-1" />
            {loading ?
                <Skeleton active avatar />
                :
                <Table
                    dataSource={filteredData}
                    columns={columns}
                    loading={loading}
                    rowKey={(record) => record.id}
                    bordered
                    pagination={{
                        defaultCurrent: 1,
                        current: currentPage,
                        defaultPageSize: pageSize,
                        total: total,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        onChange: onPageChange,
                        pageSizeOptions: [2, 5, 10, 20, 50, 100],
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total>1 ? 'Logs' : 'Log'}`,
                      }}
                    size="middle"
                />}
                <ViewApplicationLogs record={visible} setVisible={setVisible} tabList={tabList}/>
        </div>
    );
}

export default ApplicationErrorList